import {ReactComponent as NPFavicon } from '../../../../../src/assets/logo/np-favicon.svg';
import i18n from '../../../../utils/translations/i18n';
import "./index.scss";

declare const window: any;

const PCCBanner = ({ className = "" }) => {
  const { t } = i18n;

  const handleClick = (e) => {
    e.preventDefault();
    window.np.showModalPopup('pccinfo')
  };
  
  return (
    <div className={`pcc-banner ${className}`}>
      <div className='brand-logo'>
        <NPFavicon />
      </div>
      <div className={`pcc-banner__content ${className}`}>
        <span className="pcc-banner__text">{t('pcc.buy_now_customize_later')}</span>
        <a className="pcc-banner__learn-more" onClick={handleClick}>{t('checkout_payment.learn_more')}</a>
      </div>
    </div>
  );
};

export default PCCBanner;
